import { createSlice } from "@reduxjs/toolkit";

export enum AlertType {
  ERROR = "error",
  WARNING = "warning",
  INFO = "info",
  SUCCESS = "success",
}

export type AlertItem = {
  severity: AlertType;
  title: string;
  content: string;
};

export type CommonState = {
  alertState: AlertItem[];
  apiLoading: boolean; // api request is loading or not
  hashEntry?: any; // resource.hash-entry document
};

const commonState: CommonState = {
  alertState: [],
  apiLoading: false,
  hashEntry: {} as any,
};

type AddAlertAction = {
  payload: AlertItem[];
};

type DismissAlertAction = {
  payload: {
    index: number;
  };
};

export const commonSlice = createSlice({
  name: "common",
  initialState: commonState,
  reducers: {
    appendAlertAction: (state: CommonState, action: AddAlertAction) => {
      return {
        ...state,
        alertState: [...state.alertState, ...action.payload],
      };
    },
    dismissAlertAction: (state: CommonState, action: DismissAlertAction) => {
      let currentAlert = [...state.alertState];
      currentAlert.splice(action.payload.index, 1);
      return {
        ...state,
        alertState: currentAlert,
      };
    },
    showLoadingAction: (state: CommonState) => {
      return {
        ...state,
        apiLoading: true,
      };
    },
    hideLoadingAction: (state: CommonState) => {
      return {
        ...state,
        apiLoading: false,
      };
    },
    setHashEntryAction: (state: CommonState, action: { payload: any }) => {
      return {
        ...state,
        hashEntry: action.payload,
      };
    },
  },
});
